import type { FacetAttribute } from 'searchkit';

export const FACET_ATTRIBUTE = {
  query: 'query',
  category: 'category',
  price: 'price',
  tags: 'tags',
  color: 'color',
  product_type: 'product_type',
  shape: 'shape',
  lead_time: 'lead_time',
  material_filter: 'material_filter',
  length: 'length',
  bed_frame_size: 'bed_frame_size',
  upholstery: 'upholstery',
  bed_slat_height: 'bed_slat_height',
  rug_size: 'rug_size',
  styles: 'styles',
  overall_sit_rating: 'overall_sit_rating',
  seat_depth_rating: 'seat_depth_rating',
  seat_height_rating: 'seat_height_rating',
  seat_softness_rating: 'seat_softness_rating',
  fabric_type: 'fabric_type',
  fabric_feature: 'fabric_feature',
  in_stock_regions: 'in_stock_regions',
  sustainability_feature: 'sustainability_feature',
} as const;

export const FACET_ATTRIBUTES_CONFIG: FacetAttribute[] = [
  {
    attribute: FACET_ATTRIBUTE.category,
    field: 'permalink',
    type: 'string',
    nestedPath: 'categories',
  },
  {
    attribute: FACET_ATTRIBUTE.price,
    field: 'price',
    type: 'numeric',
    nestedPath: 'variants',
  },
  {
    attribute: FACET_ATTRIBUTE.tags,
    field: 'tags',
    type: 'string',
    nestedPath: 'variants',
  },
  {
    attribute: FACET_ATTRIBUTE.color,
    field: 'color',
    type: 'string',
    nestedPath: 'variants',
  },
  {
    attribute: FACET_ATTRIBUTE.product_type,
    field: 'properties.product_type',
    type: 'string',
    nestedPath: 'variants',
  },
  {
    attribute: FACET_ATTRIBUTE.shape,
    field: 'properties.shape',
    type: 'string',
    nestedPath: 'variants',
  },
  {
    attribute: FACET_ATTRIBUTE.lead_time,
    field: 'lead_time',
    type: 'numeric',
    nestedPath: 'variants',
  },
  {
    attribute: FACET_ATTRIBUTE.material_filter,
    field: 'properties.material_filter',
    type: 'string',
    nestedPath: 'variants',
  },
  {
    attribute: FACET_ATTRIBUTE.length,
    field: 'properties.length',
    type: 'numeric',
    nestedPath: 'variants',
  },
  {
    attribute: FACET_ATTRIBUTE.bed_frame_size,
    field: 'option_values.bed_frame_size.value',
    type: 'string',
    nestedPath: 'variants',
  },
  {
    attribute: FACET_ATTRIBUTE.upholstery,
    field: 'properties.upholstery',
    type: 'string',
    nestedPath: 'variants',
  },
  {
    attribute: FACET_ATTRIBUTE.bed_slat_height,
    field: 'properties.bed_slat_height',
    type: 'string',
    nestedPath: 'variants',
  },
  {
    attribute: FACET_ATTRIBUTE.rug_size,
    field: 'properties.rug_size',
    type: 'string',
    nestedPath: 'variants',
  },
  {
    attribute: FACET_ATTRIBUTE.styles,
    field: 'styles',
    type: 'string',
  },
  {
    attribute: FACET_ATTRIBUTE.overall_sit_rating,
    field: 'properties.overall_sit_rating',
    type: 'numeric',
    nestedPath: 'variants',
  },
  {
    attribute: FACET_ATTRIBUTE.seat_depth_rating,
    field: 'properties.seat_depth_rating',
    type: 'numeric',
    nestedPath: 'variants',
  },
  {
    attribute: FACET_ATTRIBUTE.seat_height_rating,
    field: 'properties.seat_height_rating',
    type: 'numeric',
    nestedPath: 'variants',
  },
  {
    attribute: FACET_ATTRIBUTE.seat_softness_rating,
    field: 'properties.seat_softness_rating',
    type: 'numeric',
    nestedPath: 'variants',
  },
  {
    attribute: FACET_ATTRIBUTE.fabric_type,
    field: 'properties.fabric_type',
    type: 'string',
    nestedPath: 'swatches',
  },
  {
    attribute: FACET_ATTRIBUTE.fabric_feature,
    field: 'properties.fabric_feature',
    type: 'string',
    nestedPath: 'swatches',
  },
  {
    attribute: FACET_ATTRIBUTE.in_stock_regions,
    field: 'in_stock_regions.raw',
    type: 'string',
    nestedPath: 'variants',
  },
  {
    attribute: FACET_ATTRIBUTE.sustainability_feature,
    field: 'properties.sustainability_feature',
    type: 'string',
    nestedPath: 'variants',
  },
] as FacetAttribute[];
